import maintainRequest from "@/maintain/utils/maintainRequest";

export default function maintainGetCarportByPage(params) {
  return maintainRequest.get(
    "/device/maintenanceMan/carport/getCarportByPage",
    {
      params,
    }
  );
}
